import { useWorkspaceAsset } from "@gripp/shared-logic";
import { LoadingIndicator, RoutineButtons, RoutineExecutionProps, SlideAction, Spacing, useSlideLayoutSafe } from "@gripp/shared-ui";
import { ScrollView, StyleSheet } from "react-native";
import { useNavigate, useParams } from "react-router";
import { RoutineSubmitSource } from '../assetUtils';

export const RoutineAllColumn = ({
  assetId,
  onItemsCountChange,
}: {
  assetId: string;
  onItemsCountChange?: (count: number) => void;
}) => {
  // Placeholder value — 'showAll' will override this.
  const initialRoutinesToShow = 50;

  const navigate = useNavigate();
  const { issueId } = useParams();
  const slideLayoutContext = useSlideLayoutSafe();
  const { workspaceAsset, isLoading } = useWorkspaceAsset(assetId);

  const onRoutineSelected = async (routine: RoutineExecutionProps) => {
    if (
      slideLayoutContext &&
      !location.pathname.includes('/routines/')
    ) {
      await slideLayoutContext.onSlideChange(SlideAction.NEXT);
    }

    // In activities context, use the activity-prefixed URL so back navigation
    // returns correctly through the activities → asset → routines chain.
    const baseUrl = `${assetId}/routines/${routine.routine?.id}?from=${RoutineSubmitSource.RoutinesList}`;
    const routineUrl = issueId
      ? `/activities/${issueId}/asset/${baseUrl}`
      : `/assets/${baseUrl}`;

    navigate(routineUrl);
  };

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (!assetId || !workspaceAsset) {
    return null;
  }

  return (
    <ScrollView style={styles.routineButtonContainer}>
      <RoutineButtons
        workspaceAsset={workspaceAsset}
        showAll
        initialRoutinesToShow={initialRoutinesToShow}
        onRoutineSelected={onRoutineSelected}
        onNavigateToRoutineEdit={() =>
          navigate(
            `/routines/edit`,
            { 
              relative: 'path',
              state: { from: RoutineSubmitSource.RoutinesList } 
            }
          )
        }
        onItemsCountChange={onItemsCountChange}
      />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  routineButtonContainer: {
    padding: Spacing.basePadding.paddingHorizontal,
    flex: 1,
  },
});
